import { GroupSessionsQuery, GroupSessionsQueryVariables } from 'generated/graphql'
import { getNodes } from 'graphql/utils'
import { usePagination, DEFAULT_ITEMS_PER_PAGE } from '../pagination'
import { groupSessionsQuery } from './graphql/query'

const getList = (data) => getNodes(data?.event?.groupSessions)
const getPageInfo = (data) => data?.event?.groupSessions?.pageInfo
const getTotalCount = (data) => data?.event?.groupSessions?.totalCount

export const useGroupSessions = (
    { ...variables }: GroupSessionsQueryVariables
) => usePagination<GroupSessionsQuery, GroupSessionsQueryVariables>({
    query: groupSessionsQuery,
    initPage: 1,
    initItemsPerPage: DEFAULT_ITEMS_PER_PAGE,
    getList,
    getPageInfo,
    getTotalCount,
    variables,
})
